<div class="list-viewer-container" *ngIf="itemList.length">
    <div class="list-items" *ngFor="let item of itemList" [class.hide]="item.is_deleted">
        <img class="user-icon" *ngIf="type == 'user'" src="./assets/images/user.png">
        <div class="item-text" (click)="onClick($event,item)" [class.read-only]="item.readOnly"> {{item.text || item.name}}</div>
        <img class="remove-button" *ngIf="!item.readOnly" (click)="onRemove($event,item)" src="assets/images/recyclebin.svg">
    </div>
</div>